module.exports = new __parcel__URL__("boing.92429357.mp3").toString();